import { put, select, take } from 'redux-saga/effects';

import { runAmountCalculations, SET_GRAND_TOTAL } from '../productCartHandler/productCartModule';
import { CONSUMER_FEES_FETCH_FAILED, requestConsumerFees, SET_CONSUMER_FEES } from '../fees/consumerFeeModule';
import { getCurrencyCode } from '../productCartHandler/productCartSelectors';
import { applyActivePromo } from '../promo/promoModule';
import { getShippingPromoData } from '../promo/promoSelectors';
import { getFeesCurrencyCode } from '../fees/consumerFeeSelectors';
import { resetPreferredValues } from '../routing/flowProgressModule';

export default function* cartDependencySaga() {
    const currencyCode = yield select(getCurrencyCode);
    const feesCurrencyCode = yield select(getFeesCurrencyCode);

    
    
    if (currencyCode && (!feesCurrencyCode || feesCurrencyCode !== currencyCode)) {
        yield put(requestConsumerFees(currencyCode));
        
        yield take([SET_CONSUMER_FEES, CONSUMER_FEES_FETCH_FAILED]);
    }

    
    yield put(runAmountCalculations());

    
    yield take(SET_GRAND_TOTAL);

    
    if (getShippingPromoData) {
        yield put(applyActivePromo(true));
    } else {
        yield put(applyActivePromo());
    }
    
    
    yield put(resetPreferredValues());
}
